import * as React from 'react';
import './LinkPortal.css';
import { inject, observer } from 'mobx-react';
import { Store } from './stores';
import {IAIcon} from './icons/Icon';
import MessagesService from './services/MessagesService';

export interface IProps {
  store?: Store;
}

export interface IState {
  showSpinner: boolean;
  errorMessage: string;
}

@inject('store')
@observer
export default class LinkPortal extends React.Component<IProps, IState> {
  
  constructor(props) {
    super(props);
    this.state = {
      showSpinner: true,
      errorMessage: ""
    };
  }

  componentDidMount(){
    var parsedURL = this.parseURL(window.location.href);
    if (parsedURL){
      MessagesService.getDirectMessageUrl(parsedURL.tenant, parsedURL.instance).then((archiveLink) => {
        window.location.href = `${archiveLink}?instance=${parsedURL.instance}&messageId=${parsedURL.messageId}`;    
      }).catch(() => {
        this.setState({showSpinner: false, errorMessage:"Could not find archive link"});
      });
    }
    else {
      this.setState({errorMessage: "Missing valid tenant, instance or message id", showSpinner: false});
    }
  }

  render() {
    return (
      <div className="IA_linkPortal">
        {this.state.showSpinner ? 
          <div className = 'SpinnerContainer'>
            <div className = 'Spinner'>
              <IAIcon 
                title="Spinner"
                size={40}
                color={"#aaaaaa"}/>
            </div>
          </div>
          :
          <div className="block"> 
            <div className="centered">
              <div className="large-illustration">
                <img alt="illustration of a sad message icon" src="data:image/png;base64,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"/>
              </div>
              <div className="content-wrapper" role="main">
                <div style={{marginLeft:"20px"}}>
                  <div className="text-header">
                    Hmmmm! It seems we are having problems finding the right way to open the message.
                  </div>
                    <div className="text-content">
                      <p> Technical details about the issue:</p>
                      <p><i>{this.state.errorMessage}</i></p>
                    </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    );
  }

  private parseURL(urlString:string): {tenant:string; instance:string; messageId:string;} {
    var url = new URL(urlString);
    var pathValues = url.pathname.substring(1).split("/");

    if (!pathValues[0] || !pathValues[1] || !pathValues[2]){
      return null;
    } else {
      return {
        tenant: pathValues[0],
        instance: pathValues[1],
        messageId: pathValues[2]
      };
    }
  }
}